<template>
    <div class="rec-company-list">
        <div class="company-top flex-center">
            <img :src="company.logo" alt="" />

            <div class="company-info">
                <div class="company-info_title ellipsis-single">{{ company.name }}</div>

                <div class="company-info_tags">
                    <i class="tag">{{ company.funding_stage }}</i>
                    <i class="tag">{{ company.staff_size }}</i>
                    <i class="tag">{{ company.industry }}</i>
                </div>
            </div>
        </div>

        <div class="company-bottom flex-center">
            <div class="num">
                <span>{{ company.position_num }}</span>
                在招职位
            </div>

            <div class="split-line"></div>

            <div class="boss"><span>1</span>位boss</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    props: {
        company: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.rec-company-list {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    background-color: #ffffff;

    .company-top {
        padding: 16px 24px;
        gap: 8px;

        img {
            width: 58px;
            height: 58px;
            border-radius: 50%;
            object-fit: cover;
        }

        .company-info {
            flex: 1;
            min-width: 0;

            &_title {
                font-size: 16px;
                margin-bottom: 8px;
            }

            &_tags {
                display: flex;
                gap: 6px;

                i {
                    font-style: normal;
                    font-size: 11px;
                    padding: 4px 10px;
                    border-radius: 4px;
                    background-color: #ededee;
                }
            }
        }
    }

    .company-bottom {
        width: 100%;
        gap: 40px;
        height: 40px;
        background-color: #f8fbfc;

        .split-line {
            height: 16px;
            width: 1px;
            background-color: #b8bbcc;
        }

        .num,
        .boss {
            span {
                font-size: 20px;
                font-weight: 500;
                margin-right: 4px;
            }
        }
    }
}
</style>
